// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\GoogleAuthUrlResponse

export type GoogleAuthUrlApiResponse = {
	auth_url: string;
};

export type GoogleAuthUrl = {
	auth_url: string;
};

export function hydrateGoogleAuthUrl(data: GoogleAuthUrlApiResponse): GoogleAuthUrl {
	return { ...data };
}